import type { DocumentAudience } from '@/blocks/domain/helpers/lineItemsColumnKeys';
import { buildPriceBookBySheetView } from './buildPriceBookBySheetView';
import { selectPriceBookLayout } from './selectPriceBookLayout';

/**
 * Splittable row count for `paginate()`: 0 for the atomic authoring shape, the audience-filtered
 * printable rows for by-sheet, and every seeded row for the flat table (unchanged behaviour).
 */
export function countPriceBookRows(rows: readonly unknown[] | undefined, binding: string | undefined, audience: DocumentAudience): number {
  const layout = selectPriceBookLayout(rows, binding);
  if (layout === 'sections') return 0;
  if (layout === 'by-sheet') return buildPriceBookBySheetView(rows, { audience, currency: 'USD', cultureTag: 'en-US' }).rowCount;
  return rows?.length ?? 0;
}
